import React from 'react';

interface CheckIconProps {
  width?: number,
  height?: number
}

const CheckIcon = ({width = 14, height = 14}: CheckIconProps) => {

  return (
    <svg width={width} height={height} viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.41 0L0 1.41L4.58 6L0 10.59L1.41 12L7.41 6L1.41 0Z" fill="#BCBBC1"/>
    </svg>

  );
};

export default CheckIcon;